import { TDay } from 'src/api/getMenu/types';
import { IMealtime } from 'src/types/mealtimes.types';
import { getSchedulesTimes } from '../getSchedulesTimes/getSchedulesTimes';

export const doSchedulesOverlap = (
  startTimeFormValue: string,
  endTimeFormValue: string,
  isEnabled: boolean,
  day: TDay,
  mealtimes: IMealtime[],
) => {
  const times = getSchedulesTimes(day, mealtimes);
  return times.some(
    ([dayStartTime, dayEndTime]: string[]) =>
      isEnabled && endTimeFormValue >= dayStartTime && startTimeFormValue <= dayEndTime,
  ); // check if there's an overlap in intervals for the same enabled day
};
